import { ProfilePageData } from "libs/profile-repo"
import { ProfileContentPC } from "views/Profile"
import Container from "./Container"

export function ShopModuleProfilePC({
  profileData,
}: {
  profileData: ProfilePageData
}) {
  // console.log("profileData", profileData)
  return (
    <Container>
      <ProfileContentPC {...profileData} />
    </Container>
  )
}
